"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mergeFallbacks = function (fallBackLocales) { return function (messages) { return (tslib_1.__assign(tslib_1.__assign({}, fallBackLocales), messages)); }; };
var replaceTerms = function (customTerms) { return function (messages) {
    return Object.keys(messages).reduce(function (acc, messageKey) {
        var _a;
        return (tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[messageKey] = customTerms.reduce(function (m, term) {
            return m.replace(new RegExp("(^|\\W)" + term.originalTerm + "($|\\W)", 'gi'), "$1" + term.customTerm.replace(/\\/g, '\\\\') + "$2");
        }, messages[messageKey]), _a)));
    }, {});
}; };
exports.buildMessages = function (locales, fallBackLocales) { return function (locale, customTerms) {
    if (customTerms === void 0) { customTerms = []; }
    var lcLocale = locale.toLowerCase();
    var index = Object.keys(locales).find(function (k) { return lcLocale.startsWith(k); });
    var messages = locales[lcLocale] || (index ? locales[index] : fallBackLocales);
    return replaceTerms(customTerms)(mergeFallbacks(fallBackLocales)(messages));
}; };
exports.default = exports.buildMessages;
